import React, { useEffect, useMemo } from "react";
import BidHistoryCard from "./BidHistoryCard";
import { Button } from "../../../../../shadcn/components/ui/button";
import { useSelector } from "react-redux";
import { NoBidsHammer } from "app-v2";

interface BidHistorySectionProps {
  app?: "bidder" | "banker" | "others" | false;
  bidsEvent: any;
  wrongBidsEvent: any;
  setShowBidHistoryModel: any;
  isSwissAuction: boolean;
}
export default function BidHistorySection({
  app,
  bidsEvent,
  wrongBidsEvent,
  setShowBidHistoryModel,
  isSwissAuction = false,
}: BidHistorySectionProps) {
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const allBids = useMemo(() => {
    if (!bidsEvent.length && !wrongBidsEvent.length) return [];

    return [...bidsEvent, ...wrongBidsEvent]
      .filter((bid) => bid.bid_timestamp)
      .map((bid) => ({
        ...bid,
        status: wrongBidsEvent.includes(bid) ? "Failed" : "Success",
      }))
      .sort((a, b) => {
        return b.bid_timestamp - a.bid_timestamp;
      });
  }, [bidsEvent, wrongBidsEvent]);

  useEffect(() => {}, []);
  return (
    <section className="bg-[#FAF7FA] px-2 lg:px-4 pt-4">
      <div className="flex justify-between text-sm mb-2">
        <div>Bid History</div>
        {allBids.length > 0 && (
          <Button
            className="h-8 text-sm bg-[#FAF7FA] underline text-brand-textBlack hover:bg-[#FAF7FA]"
            onClick={() => setShowBidHistoryModel(true)}
          >
            View All
          </Button>
        )}
      </div>
      <div className="flex flex-col gap-1 h-[185px] overflow-y-auto show-scrollbar">
        {allBids.length > 0 ? (
          allBids.slice(0, 5).map((bid: any, index: number) => (
              <BidHistoryCard
                key={`BidHistoryCard_${index}`}
                index={index}
                typeOfBid={
                  app === "banker"
                    ? "others"
                    : bid?.user_uuid === user?.uuid
                    ? "user"
                    : "others"
                }
                bidsPrice={bid.bidding_amount}
                bidTimestamp={bid.frontend_timestamp}
                showStatus={false}
                bidsStatusText={bid.status}
                userName={onboardingData?.name}
                app={app}
                bidData={bid}
                isSwissAuction={isSwissAuction}
              />
            ))
        ) : (
          <div className="">
            {/* {app == "banker" ? ( */}
            <div className="flex flex-col gap-4 w-1/2 sm:w-1/4 mx-auto items-center justify-center">
              <NoBidsHammer />
              <p className="text-bankerColor text-sm font-semibold text-center font-sans">
                For this auction, no bid history is available
              </p>
            </div>
            {/* ) : ( */}
            {/* <div className="text-[10px] lg:text-sm font-sans text-brand-orange text-center mt-8">
              There are currently no bids. Be the first to participate!
            </div> */}
            {/* )} */}
          </div>
        )}

        {/* <BidHistoryCard
          typeOfBid="user"
          bidsTagText="Your bid has failed" //Your bid has failed,New bid placed
          bidsPrice={1900000}
          bidTimestamp={Date.now()}
          showStatus={false}
          bidsStatusText="Failed"
          userName="r"
        />
        <BidHistoryCard
          typeOfBid="others"
          bidsTagText="New bid placed" //Your bid has failed,New bid placed
          bidsPrice={1800000}
          bidTimestamp={Date.now()}
          showStatus={false}
          bidsStatusText="Success"
        /> */}
      </div>
    </section>
  );
}
